import { FaSearch } from "react-icons/fa";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
  background-color: #e5f8fa;
  font-family: Arial, sans-serif;
`;

export const WrapContent = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  width: 75%;
  height: 800px;
`;

export const Header = styled.div`
  align-self: self-start;
  font-size: 14px;

  h1{
        margin: -10px 9px;
        padding: 0;
        color: #FF5742;
    }

    h2{
        color: black;
        font-size: 15px;
        margin-top: auto;
    }

    h3{
        color: #005CA9;
        font-size: 30px;
        margin-left: 9px;
        margin-top: 10px;
    }
`;

export const Card = styled.div`
  position: relative;
  background-color: white;
  padding: 30px 40px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  width: 90%;
  margin-top: 30px;

  h2{
        font-size: 13px;
        font-weight: 200;
        margin-top: -10px;
    }
`;

export const RowOptions = styled.div`
    display: flex;
    flex-direction: row;
    gap: 30px;

    
`

export const Question = styled.p`
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 15px;
  margin-top: 12px;
  color: #4a4a4a;
`;

export const Option = styled.label`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  font-size: 14px;
  color: #4a4a4a;
  cursor: pointer;

  input {
    appearance: none;
    margin: 0;
    margin-right: 10px;
    width: 18px;
    height: 18px;
    border: 2px solid #005CA9;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;
    transition: border 0.3s ease-in-out;
  }

  input:checked {
    border-color: #FF5641;
    background-color: #FF5641;
  }
`;


export const Footer = styled.footer`
  position: absolute;
  bottom: 20px;
  left: 20px;
  font-size: 12px;
  color: #4a4a4a;
`;

export const Logo = styled.img`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 70px;
`;

export const WrapContractInfo = styled.div`
    display: flex;
    flex-direction: column;
    padding-top: 20px;

    h4{
        color: black;
        font-size: 20px;
        font-weight: 300;
        margin-top: 5px;
    }

`
interface NewRegisterCardProps {
    isExpanded?: boolean;
}

export const SearchContainer = styled.div<NewRegisterCardProps>`
    position: relative;
    width: 25%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 0;
    margin-bottom: 20px;
`;

export const SearchIcon = styled(FaSearch)`
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #005CA9;
    
    cursor: pointer;
`;

export const ContractInput = styled.input`
    position: relative;
    margin-left: 0;
    width: 100%;
    height: 40px;
    background-color: #F2F2F2;
    border: none;
    color: black;
    font-size: 18px;
    font-weight: 500;
    align-self: flex-start;
    padding-left: 9px;
    display: flex;
    justify-content: space-around;
    border-end-end-radius: 20px;
    border-end-start-radius: 20px;
    border-start-end-radius: 20px;
    border-start-start-radius: 20px;
    transition: all 0.3s ease;

    &:focus {
        border: 1px solid #5c8e;
        box-shadow: 0 0 8px rgba(92, 142, 200, 0.5); 
        outline: none; 
    }
`

export const ContinueButton = styled.button`
    background-color: #FF5641;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 120px;
    padding: 8px;
    border: none;
    border-radius: 50px / 40px;
    color: #FFFFFF;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    position: absolute;
    top: 210px;
    left: 900px;
`

export const ContinueButton2 = styled.button`
    background-color: #FF5641;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 120px;
    padding: 8px;
    border: none;
    border-radius: 50px / 40px;
    color: #FFFFFF;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    position: absolute;
    bottom: 440px; 
    right: 400px; 
`

export const Select = styled.select`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 200px;
  background: white;
  cursor: pointer;
`;